export default "__VITE_ASSET__9603e1b8__"